module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showDismissibleAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showDismissibleAlert = false
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageAlert) + "\n  ")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.monitores), function(monitor) {
    return _c('div', {
      key: monitor.id,
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "box box-success"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(monitor.nomemaquina) + " - Dados completos")]), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('VueSvgGauge', {
      attrs: {
        "start-angle": -110,
        "end-angle": 110,
        "value": monitor.oee,
        "separator-step": 10,
        "separator-thickness": 1,
        "min": 0,
        "max": 100,
        "gauge-color": [{
          offset: 0,
          color: '#347AB0'
        }, {
          offset: 100,
          color: '#8CDFAD'
        }],
        "scale-interval": 0.1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-box-marcus"
    }, [_c('h1', [_c('b', [_vm._v(_vm._s(monitor.oee) + " %")])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_vm._m(2, true), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Disponibilidade")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(monitor.oeedisponibilidade) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Performance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(monitor.oeeperformance) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qualidade")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(monitor.oeequalidade) + " %")])])])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "box box-success"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h4', {
      staticClass: "box-title"
    }, [_vm._v(_vm._s(monitor.nomemaquina) + " - Dados com Ordem")]), _vm._v(" "), _vm._m(3, true)]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('VueSvgGauge', {
      attrs: {
        "start-angle": -110,
        "end-angle": 110,
        "value": monitor.oee2,
        "separator-step": 10,
        "separator-thickness": 1,
        "min": 0,
        "max": 100,
        "gauge-color": [{
          offset: 0,
          color: '#347AB0'
        }, {
          offset: 100,
          color: '#8CDFAD'
        }],
        "scale-interval": 0.1
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-box-marcus"
    }, [_c('h1', [_c('b', [_vm._v(_vm._s(monitor.oee2) + " %")])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [_c('table', {
      staticClass: "table table-condensed"
    }, [_vm._m(4, true), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Disponibilidade")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(monitor.oeedisponibilidade2) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Performance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(monitor.oeeperformance) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Qualidade")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(monitor.oeequalidade) + " %")])])])])], 1)])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Indicador")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Indicador")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df81aa26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/OEE.vue
// module id = 653
// module chunks = 1